import { defineStore } from "pinia"
import { timestamp } from "~/utils/utils"

export const useCurrentDefenderAdHocStore = defineStore(
  "currentDefenderAdHoc",
  {
    state: () => ({
      confirmed: false,
      profile: {},
    }),
    actions: {
      confirmAdHocProfile(payload) {
        this.profile = {
          ...payload.profile,
          updated: timestamp(),
        }
        this.confirmed = true
      },
      resetCurrentDefenderAdHoc() {
        this.profile = {}
        this.confirmed = false
      },
      setCurrentDefenderAdHoc(payload) {
        this.profile = payload
        this.confirmed = true
      },
    },
    persist: {
      key: "unitcrunch-defender-adhoc",
    },
  }
)
